import React, { useEffect, useRef, useState } from "react";
import "../Message/Message.css";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import { Dropdown, Tab, Tabs } from "react-bootstrap";
import { msg_frst_prson, msg_list } from "../../../assets";
import {
  BsFillSendFill,
  BsThreeDots,
  BsThreeDotsVertical,
} from "react-icons/bs";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { GoChevronRight } from "react-icons/go";
import { CiSearch } from "react-icons/ci";
import GroupChat from "./chatMessageModule/GroupChat";
import MembersChat from "./chatMessageModule/MembersChat";
import { socket } from "../../../utils/socket";

const MessageBox = ({
  selectedChatType,
  selectedChat,
  showChatUsers,
  setSelectedChat,
  chatId,
  memberDetails,
  setGroupDetails,

  isReplay,
  setIsReplay,
  selectedReplyData,
  setSelectReplyData,
  chatType = 'GROUP',
}) => {
  // console.log(selectedChat,'selectedChat');

  const [chatMessage, setChatMessage] = useState([]);
  const [receiverData, setReceiverData] = useState({});
  const [totalPages, setTotalPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const chatContainerRef = useRef(null);


  //   Receive Chat Message
  const receiveChatMessage = (data) => {
    // console.log('data receiveChatMessage', data,)
    if (!data?.data?.status) {
      const { success, data: chatMessage, meta } = data;
      if (success) {
        setReceiverData(null);
        setChatMessage((prev) => [...chatMessage, ...prev] || []);
        setTotalPages(meta?.totalPages);
        scrollToBottom(meta?.page);
        setGroupDetails(meta)
      }
    } else {
      // console.log(data, "Data for receiver data");

      setReceiverData(data?.data);
    }
  };

  // Receive Chat Message
  useEffect(() => {
    socket.on("RECEIVE_CHAT_MESSAGE_LIST", receiveChatMessage);

    return () => {
      socket.off("RECEIVE_CHAT_MESSAGE_LIST", receiveChatMessage);
    };
  }, []);

  const fetchMessages = (page) => {
    if (chatId || selectedChat?._id) {
      socket.emit("REQUEST_CHAT_MESSAGE_LIST", {
        page: page || currentPage,
        limit: 50,
        _chat: chatId || selectedChat?._id,
      });
    }
  };

  useEffect(() => {
    fetchMessages(1);
    return () => {
      setCurrentPage(1);
      setChatMessage([]);
    };
  }, [chatId, selectedChat?._id]);

  // console.log({ currentPage });

  const scrollToBottom = (page) => {
    const chatContainer = chatContainerRef.current;
    if (chatContainer) {
      const currentScrollHeight = chatContainer.scrollHeight;
      setTimeout(() => {
        if (page === 1) {
          chatContainer.scrollBottom = 0;
        } else {
        }
        chatContainer.scrollTop =
          chatContainer.scrollHeight - currentScrollHeight;
      }, 0);
    }
  };


  return (
    <>
      {/* {selectedChatType === "GROUP" ? ( */}
      {chatType === "GROUP" ? (
        <GroupChat
          fetchMessages={fetchMessages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          selectedChat={selectedChat}
          chatMessage={chatMessage}
          setChatMessage={setChatMessage}
          chatContainerRef={chatContainerRef}
          totalPages={totalPages}
          showChatUsers={showChatUsers}
          chatId={chatId}
          // groupDetails={groupDetails}
          isReplay={isReplay}
          setIsReplay={setIsReplay}
          selectedReplyData={selectedReplyData}
          setSelectReplyData={setSelectReplyData}
        />
        // ) : selectedChatType === "MEMBER" ? (
      ) : chatType === 'MEMBER' ? (
        <MembersChat
          selectedChat={selectedChat}
          chatMessage={chatMessage}
          setChatMessage={setChatMessage}
          receiverData={receiverData}
          fetchMessages={fetchMessages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          chatContainerRef={chatContainerRef}
          totalPages={totalPages}
          chatId={chatId}
          memberDetails={memberDetails}

          isReplay={isReplay}
          setIsReplay={setIsReplay}
          selectedReplyData={selectedReplyData}
          setSelectReplyData={setSelectReplyData}
        />
      ) : null}
    </>
  );
};

export default MessageBox;
